
/* eslint-disable */
import { SET_PDS_DOCUMENT_LIST } from './constants'

export const updateDocumentList = payload => ({
    type: SET_PDS_DOCUMENT_LIST,
    payload
  });